const de = {
  metaTitle: "SkillSynergy | Blog",
  metaDescription:
    "Notizen zu Programmierung, KI und dem Erlernen der Softwareentwicklung, von den Dozenten von SkillSynergy.",
  navLabel: "Blog",
  eyebrow: "Texte",
  title: "Notizen aus dem Kursraum",
  lead: "Gelegentliche Texte über Programmierung, KI und das, was wirklich zu lernen lohnt.",
  readTime: (minutes: number) => `${minutes} Min. Lesezeit`,
  backToBlog: "Zurück zu allen Beiträgen",
  publishedOn: "Veröffentlicht am",
  englishOnlyNotice: "Dieser Artikel ist nur auf Englisch verfügbar.",
  readMore: "Artikel lesen",
};

export default de;
